<div class="auth-settings-root">
  <form [formGroup]="form">
    <div class="mb-3">
      <input type="checkbox" (change)="checkChanged()" [formControl]="adEnabled" />
      <span class="uv-checkbox-label auth-settings-heading-1">Enable Active Directory Users and Groups</span>
    </div>
    <div class="mb-3 auth-settings-row-1">
      <span class="auth-settings-heading-2">Basic Settings</span>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <span class="auth-settings-label">Domain Names (e.g., acme.com)</span>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <textarea class="form-control auth-settings-domains" [formControl]="adDomainNames"></textarea>
    </div>
    @if (adDomainNames.hasError('adDomainNamesRequired')) {
      <div class="mb-3 auth-settings-row-2">
        <div class="auth-settings-domains-error alert alert-danger">
          This field is required.
        </div>
      </div>
    }
    <div class="mb-3 auth-settings-row-2">
      <span class="auth-settings-label">Query Page Size:</span>
      <input type="number" pInputText min="1" max="1000" class="auth-settings-page-size" [formControl]="adQueryPageSize" />
    </div>
    @if (adQueryPageSize.hasError('minValue') || adQueryPageSize.hasError('maxValue')) {
      <div class="mb-3 auth-settings-row-2">
        <div class="auth-settings-page-size-error alert alert-danger">
          This field is required and must be in the range 1 - 1000.
        </div>
      </div>
    }
    <div class="mb-3 auth-settings-row-2">
      <input type="checkbox" [formControl]="adAllowLdapReferrals" />
      <span class="uv-checkbox-label">Allow LDAP Referrals</span>
      <span style="padding-left: 5px;">&nbsp;</span>
      <info width="500px">Enabling LDAP referrals can make Active Directory operations slow. Only enable this if you really need it.</info>
    </div>
    <div class="mb-3 auth-settings-row-1">
      <span class="auth-settings-heading-2">Authentication Settings</span>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <input type="radio" class="auth-settings-check" (change)="checkChanged()" [formControl]="adAuthType" value="Windows" [checked]="adAuthType.value == 'Windows'" />
      <span class="uv-checkbox-label auth-settings-auth-option">Use Windows Authentication</span>
      <span style="padding-left: 5px;">&nbsp;</span>
      <info width="500px">The computer running UVexplorer Server must be joined to an Active Directory domain in order to use this option.</info>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <input type="radio" class="auth-settings-check" (change)="checkChanged()" [formControl]="adAuthType" value="LDAP" [checked]="adAuthType.value == 'LDAP'" />
      <span class="uv-checkbox-label auth-settings-auth-option">Use LDAP Authentication</span>
    </div>
    <div class="mb-3 auth-settings-row-3">
      <span class="auth-settings-heading-3">Active Directory Server</span>
    </div>
    <div class="mb-3 auth-settings-row-4">
      <span class="auth-settings-label">Hostname or IP Address:</span>
      <input type="text" pInputText class="auth-settings-host-or-ip" [formControl]="adServerHostIp" />
    </div>
    @if (adServerHostIp.hasError('adServerHostIpRequired')) {
      <div class="mb-3 auth-settings-row-4">
        <div class="auth-settings-ip-error alert alert-danger">
          This field is required.
        </div>
      </div>
    }
    <div class="mb-3 auth-settings-row-4">
      <span class="auth-settings-label">Port Number:</span>
      <input type="number" pInputText min="1" max="65535" class="auth-settings-port" [formControl]="adServerPort" />
      <input type="checkbox" (change)="useSslChanged()" [formControl]="adUseSsl" class="auth-settings-use-ssl" />
      <span class="uv-checkbox-label auth-settings-label">Use SSL</span>
    </div>
    @if (adServerPort.hasError('adServerPortRequired') || adServerPort.hasError('adServerPortValid')) {
      <div class="mb-3 auth-settings-row-4">
        <div class="auth-settings-port-error alert alert-danger">
          This field is required and must be in the range 1 - 65535.
        </div>
      </div>
    }
    <div class="mb-3 auth-settings-row-1">
      <span class="auth-settings-heading-2">Update Settings</span>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <input type="checkbox" [formControl]="adAutoSyncDirectoryDataEnabled" (change)="checkChanged()" />
      <span class="uv-checkbox-label">Automatically refresh cached Active Directory data every</span>
      <input class="form-control auto-sync-input" type="number" min="0" max="30" [formControl]="adAutoSyncDirectoryDataDays" />
      <span class="auto-sync-text">days</span>
      <input class="form-control auto-sync-input" type="number" min="0" max="23" [formControl]="adAutoSyncDirectoryDataHours" />
      <span class="auto-sync-text">hours</span>
      <input class="form-control auto-sync-input" type="number" min="0" max="59" [formControl]="adAutoSyncDirectoryDataMinutes" />
      <span class="auto-sync-text">minutes</span>
      <span style="padding-left: 5px;">&nbsp;</span>
      <info width="500px">Auto update will use the Active Directory admin credentials last used to save Active Directory settings.</info>
    </div>
    @if (adAutoSyncDirectoryDataDays.hasError('required') || adAutoSyncDirectoryDataDays.hasError('min') || adAutoSyncDirectoryDataDays.hasError('max')) {
      <div
        class="mb-3 auth-settings-row-2">
        <div class="col-lg-3 alert alert-danger">
          Days value must be in the range 0 - 30
        </div>
      </div>
    }
    @if (adAutoSyncDirectoryDataHours.hasError('required') || adAutoSyncDirectoryDataHours.hasError('min') || adAutoSyncDirectoryDataHours.hasError('max')) {
      <div
        class="mb-3 auth-settings-row-2">
        <div class="col-lg-3 alert alert-danger">
          Hours value must be in the range 0 - 23
        </div>
      </div>
    }
    @if (adAutoSyncDirectoryDataMinutes.hasError('required') || adAutoSyncDirectoryDataMinutes.hasError('min') || adAutoSyncDirectoryDataMinutes.hasError('max')) {
      <div
        class="mb-3 auth-settings-row-2">
        <div class="col-lg-3 alert alert-danger">
          Minutes value must be in the range 0 - 59
        </div>
      </div>
    }
    @if (form.hasError('nonEmptyAutoSyncSettings')) {
      <div
        class="mb-3 auth-settings-row-2">
        <div class="col-lg-3 alert alert-danger">
          A time frame of 15 minutes or more must be specified
        </div>
      </div>
    }
    <div class="auth-settings-divider"></div>
    <div>
      <div style="display: inline-block; width: 50px;">&nbsp;</div>
      <button pButton (click)="onSave()" [disabled]="!enableSave()" label="Save Active Directory Settings"></button>
    </div>
  </form>

  <ad-admin-dialog [(display)]="adAdminDialogVisible" messageType="group" [domains]="adAdminDialogDomains"
    (onOk)="onAdAdminDialogOkClicked($event)" (onCancel)="onAdAdminDialogCancelClicked()">
  </ad-admin-dialog>

</div>